"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeletedProject = void 0;
const mongoose_1 = require("mongoose");
const enum_1 = require("../enum");
const projectSchema = new mongoose_1.Schema({
    name: {
        type: String,
        required: true,
        unique: true,
    },
    uuid: Number,
    user_id: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "User",
        required: false,
    },
    monitor_id: {
        type: String,
        required: false,
    },
    healthCheckPath: {
        type: String,
        required: false,
    },
    preStartCommand: {
        type: String,
        required: false
    },
    domains: [
        {
            ref: "Domain",
            type: mongoose_1.Schema.Types.ObjectId,
        },
    ],
    environments: [
        {
            ref: "Env",
            type: mongoose_1.Schema.Types.ObjectId,
        },
    ],
    team: {
        ref: "Team",
        type: mongoose_1.Schema.Types.ObjectId,
    },
    server: {
        ref: "Server",
        type: mongoose_1.Schema.Types.ObjectId,
    },
    deployedInCluster: {
        type: Boolean,
        default: false,
    },
    pid: Number,
    port: Number,
    ip: String,
    dir: String,
    installCommand: String,
    buildCommand: String,
    startCommand: String,
    outputDirectory: String,
    repo: Object,
    rootDir: String,
    isPrivate: {
        type: Boolean,
        default: false,
    },
    status: {
        type: String,
        enum: Object.values(enum_1.PROJECT_STATUS),
        default: enum_1.PROJECT_STATUS.PENDING,
    },
    framework: String,
    description: String,
    logs: [
        {
            ref: "Log",
            type: mongoose_1.Schema.Types.ObjectId,
        },
    ],
    log: {
        ref: "Log",
        type: mongoose_1.Schema.Types.ObjectId,
    },
    maintenance: {
        type: Boolean,
        default: false,
    },
    passwordEnabled: {
        type: Boolean,
        default: false,
    },
    backupEnabled: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    password: {
        type: String,
        default: null,
    },
    screenshot: {
        image: String,
        public_id: String,
    },
    hasUpdates: {
        type: Boolean,
        default: false
    },
    lastProcessed: Number,
    tracking_token: String,
    from: mongoose_1.Schema.Types.ObjectId,
    container_stats_schedule_id: {
        type: String,
        default: null,
    },
    previews: [
        {
            ref: "Preview",
            type: mongoose_1.Schema.Types.ObjectId,
        },
    ],
    replicas: {
        type: Number,
        default: 3,
    },
    nomadJobId: String,
    specs: Object,
    last_requested: mongoose_1.Schema.Types.Date,
    isPaused: Boolean,
    dbImage: {
        ref: "DbImage",
        type: mongoose_1.Schema.Types.ObjectId,
        required: false,
    },
    serviceType: {
        type: String,
        enum: Object.values(enum_1.ServiceType),
        default: enum_1.ServiceType.WebService,
    },
    billable: {
        type: Boolean,
        default: false,
    },
    isPaid: {
        type: Boolean,
        default: false,
    },
    authEnabled: {
        type: Boolean,
        default: false,
    },
    last_backup_url: {
        type: String,
        default: null,
    },
    last_backup_at: {
        type: Date,
        default: null,
    },
    replica_ready: {
        type: Boolean,
        default: false,
    },
    autoscaling_group: {
        ref: "AutoScalingGroup",
        type: mongoose_1.Schema.Types.ObjectId,
        required: false,
    },
    whiteListedIps: {
        type: Array,
        required: false,
    },
    vaultPath: {
        type: String,
        default: null,
    },
    vaultToken: {
        type: String,
        default: null,
    },
}, { timestamps: true });
exports.default = (0, mongoose_1.model)("Project", projectSchema);
exports.DeletedProject = (0, mongoose_1.model)("DeletedProject", projectSchema);
